import { render, staticRenderFns } from "./NetpaHome.vue?vue&type=template&id=06134b72&scoped=true&"
import script from "./NetpaHome.vue?vue&type=script&lang=js&"
export * from "./NetpaHome.vue?vue&type=script&lang=js&"
import style0 from "./NetpaHome.vue?vue&type=style&index=0&id=06134b72&scoped=true&lang=css&"
import style1 from "./NetpaHome.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06134b72",
  null
  
)

export default component.exports